export const testimonials = {
  testimonialsPageTitle: "获奖者证言 — Aprieta y Gana",
  testimonialsPageDescription: "了解我们真实获奖者的故事。在 Aprieta y Gana 获奖的玩家证言视频。",
  testimonialsTitle: "获奖者证言",
  testimonialsSubtitle: "来自我们获奖者的真实故事",
  testimonialsFilterLabel: "筛选证言",
  testimonialsFilter_all: "全部",
  testimonialsFilter_horizontal: "水平",
  testimonialsFilter_vertical: "垂直",
  testimonialsEmpty: "暂时没有可用的证言",
  testimonialsPaginationLabel: "证言分页",
  testimonialsPrevPage: "上一页",
  testimonialsNextPage: "下一页",
  testimonialsPage: "页面",

  stickyRegisterTitle: "注册并赢取奖品！",
  stickyRegisterSubtitle: "创建免费账户，立即开始游戏",
  stickyRegisterAlreadyHaveAccount: "已有账户？",
  stickyRegisterLogin: "登录",
};
